import { ReactElement } from "react";
import {
	ActionListItem,
	DropOverActionList
} from "client/Components";
import { localize } from "client_legacy/ndaw/culture";
import { OpenItemMenuState, useItemDropOverMenuProps } from "client/Hooks";

export type GroupItemMenuProps = {
	target: HTMLElement;
	onClose: () => void;
	menuState: OpenItemMenuState;
	name: string;
	onAddIntegration: () => void;
	onDelete: () => void;
};

export const GroupItemMenu = (props: GroupItemMenuProps): ReactElement => {
	const {
		target,
		onClose,
		menuState,
		name,
		onAddIntegration,
		onDelete
	} = props;

	const {
		targetAlignment,
		contentAlignment,
		closeOnMouseDown
	} = useItemDropOverMenuProps(
		menuState,
		{
			moreMenuContentAlignment: "tr",
			moreMenuTargetAlignment: "br"
		}
	);

	return (
		<DropOverActionList
			target={target}
			onClose={onClose}
			menuTitle={name}
			targetAlignment={targetAlignment}
			contentAlignment={contentAlignment}
			closeOnMouseDown={closeOnMouseDown}
		>
			<ActionListItem
				onClick={onAddIntegration}
				text={localize("_AddIntegration")}
				trackingId="add-integration-to-group"
				icon="plus"
			/>
			<ActionListItem
				onClick={onDelete}
				text={localize("_Delete")}
				trackingId="delete-group"
				icon="trash-can"
			/>
		</DropOverActionList>
	);
};
GroupItemMenu.displayName = "GroupItemMenu";